import './skeleton.css';

export default function DashaSkeletonRow({ rows = 3 }) {
    return (
        <table width="100%">
            <tbody>
            {Array.from({ length: rows }).map((_, i) => (
                <tr key={i} className="animate-pulse">
                    <td className="py-2 px-3">
                        <div className="h-4 w-24 bg-gray-300 rounded shimmer"></div>
                    </td>

                    <td className="py-2 px-3">
                        <div className="h-4 w-10 bg-gray-300 rounded shimmer"></div>
                    </td>

                    <td className="py-2 px-3">
                        <div className="h-4 w-36 bg-gray-300 rounded shimmer"></div>
                    </td>

                    <td className="py-2 px-3">
                        <div className="h-4 w-36 bg-gray-300 rounded shimmer"></div>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}
